import { useQuery } from "@tanstack/react-query";
import { ClaimControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseData,
} from "../../../utils/utils";

interface PrEligibleClaimsParams {
  patientUuid?: string;
  // Visit the claims must belong to. The endpoint filters on it, so the query
  // stays idle until a visit has been selected.
  appointmentUuid?: string;
  enabled?: boolean;
}

/**
 * Claims of the selected visit that can be billed on a Patient Responsibility
 * (PR) invoice. Calls the PR-claims endpoint (`/api/master/claim/pr-claims`),
 * which returns the given patient's claims for that visit whose ERA/EOB posting
 * is complete (posting status PAID) and that still carry a patient
 * responsibility greater than zero — partially posted, unposted and denied
 * claims, and every other patient's or visit's claims, are excluded by the
 * backend.
 */
export const useGetPrEligibleClaims = ({
  patientUuid,
  appointmentUuid,
  enabled = true,
}: PrEligibleClaimsParams): useBaseData<any> =>
  useQuery({
    enabled: !!patientUuid && !!appointmentUuid && enabled,
    queryKey: ["get-pr-eligible-claims", patientUuid, appointmentUuid],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ClaimControllerApi(getConfigObject())
        .getPrEligibleClaims(patientUuid ?? "", appointmentUuid, getXtenantId())
        .then((it) => it?.data),
  });
